module.exports = __webpack_public_path__ + "static/media/FacistBoard_large_0.43081c17.png";